// extracted by mini-css-extract-plugin
export var hideEditor = "_ml-2";
export var infoIcon = "_ml-3";
export var label = "_ml-1";
export var labelContainer = "_ml-0";
export var readonlyText = "_ml-4";